import _assign from "object-assign";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { forwardRef, useState, useContext } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import { FormLabel } from '@jpmuitk/form-label';
import { DensityContext, withStyles } from '@jpmuitk/theme';
import { useFormFieldProps } from '@jpmuitk/form-field';
import { useA11yProps } from '@jpmuitk/utils';
import { default as Checkbox } from './Checkbox';
import { CheckboxGroupStyle } from './style';
/**
 * @param {array} checkedValues
 * @param {array} defaultCheckedValues
 * @param {function} getCheckboxProps function callback that returns the checkbox props
 *
 */

var CheckboxGroup = /*#__PURE__*/forwardRef(function CheckboxGroup(props, ref) {
  var _classnames, _classnames2;

  var contextDensity = useContext(DensityContext);

  var _useFormFieldProps = useFormFieldProps({
    focusVisible: false
  }),
      fullWidth = _useFormFieldProps.fullWidth,
      inFormField = _useFormFieldProps.inFormField,
      labelPlacement = _useFormFieldProps.labelPlacement,
      variant = _useFormFieldProps.variant;

  var _useA11yProps = useA11yProps(),
      ariaRequired = _useA11yProps['aria-required'],
      a11yProps = _objectWithoutProperties(_useA11yProps, ["aria-required"]);

  var checkboxes = props.checkboxes,
      checkedValuesProp = props.checkedValues,
      defaultCheckedValues = props.defaultCheckedValues,
      _props$density = props.density,
      density = _props$density === void 0 ? contextDensity : _props$density,
      children = props.children,
      className = props.className,
      classes = props.classes,
      legend = props.legend,
      FormControlProps = props.FormControlProps,
      LegendProps = props.LegendProps,
      row = props.row,
      rest = _objectWithoutProperties(props, ["checkboxes", "checkedValues", "defaultCheckedValues", "density", "children", "className", "classes", "legend", "FormControlProps", "LegendProps", "row"]);

  var isControlled = function isControlled() {
    return props.checkedValues !== undefined;
  };

  var initialCheckedValues = function initialCheckedValues() {
    var checkedValues;

    if (isControlled()) {
      checkedValues = props.checkedValues;
    } else {
      checkedValues = props.defaultCheckedValues;
    }

    return checkedValues;
  };

  var _useState = useState(initialCheckedValues()),
      stateCheckedValues = _useState[0],
      setStateCheckedValues = _useState[1];

  var handleChange = function handleChange(_ref) {
    var target = _ref.target;
    var name = target.name;

    if (isControlled()) {
      return null;
    }

    var isSelected = checkedValues.indexOf(name) === -1;
    var selectedValues = isSelected ? [name].concat(_toConsumableArray(checkedValues)) : checkedValues.filter(function (value) {
      return value !== name;
    });
    setStateCheckedValues(selectedValues);
  };

  var checkedValues = isControlled() ? checkedValuesProp : stateCheckedValues;
  var densityClassName = classes["".concat(density, "Density")];
  return /*#__PURE__*/React.createElement(FormControl, _assign({
    className: classnames(classes.formControlRoot, className, densityClassName, (_classnames = {}, _defineProperty(_classnames, classes.horizontalRoot, row), _defineProperty(_classnames, classes.formField, inFormField), _defineProperty(_classnames, classes.formFieldFilled, inFormField && variant === 'filled'), _defineProperty(_classnames, classes.formFieldLabelLeft, inFormField && labelPlacement === 'left'), _defineProperty(_classnames, classes.formFieldFullWidth, fullWidth), _classnames)),
    component: "fieldset"
  }, a11yProps, FormControlProps, {
    ref: ref
  }), !inFormField && /*#__PURE__*/React.createElement(FormLabel, _assign({
    className: classnames(className, classes.legend, (_classnames2 = {}, _defineProperty(_classnames2, classes.horizontal, row), _defineProperty(_classnames2, classes.vertical, !row), _classnames2)),
    component: "legend",
    labelPlacement: row ? 'left' : 'top'
  }, LegendProps), legend), /*#__PURE__*/React.createElement(FormGroup, _assign({
    className: row ? classes.formGroupHorizontal : classes.formGroupVertical
  }, rest), checkboxes && checkboxes.map(function (checkbox) {
    return /*#__PURE__*/React.createElement(Checkbox, {
      checked: checkedValues.indexOf(checkbox.value) !== -1,
      disabled: checkbox.disabled,
      key: checkbox.value,
      label: checkbox.label,
      name: checkbox.value,
      onChange: handleChange,
      value: checkbox.value
    });
  }) || children));
});
CheckboxGroup.defaultProps = {
  defaultCheckedValues: []
};
process.env.NODE_ENV !== "production" ? CheckboxGroup.propTypes = {
  /**
   * Props spread into the MuiFormControl component that wraps the everything
   */
  FormControlProps: PropTypes.objectOf(PropTypes.any),

  /**
   * Props spread onto the legend that is a MuiFormLabel component
   */
  LegendProps: PropTypes.objectOf(PropTypes.any),

  /**
   * Array which contains the checkboxes' keys to render
   */
  checkboxes: PropTypes.arrayOf(PropTypes.object),

  /**
   * The current checked options.
   * this property depends on using `checkboxes` prop and creates a controlled component
   */
  checkedValues: PropTypes.arrayOf(PropTypes.string),

  /**
   * The content of component if checkboxes data prop is not set.
   */
  children: PropTypes.node,

  /**
   * The className(s) of the component
   */
  className: PropTypes.string,

  /**
   * Class selectors required by theme
   */
  classes: PropTypes.objectOf(PropTypes.string),

  /**
   * The default selected option for un-controlled component
   */
  defaultCheckedValues: PropTypes.arrayOf(PropTypes.string),

  /**
   * The density of a component affects the style of the layout.
   * A high density component uses minimal sizing and spacing to convey the intended UI design.
   * Conversely, a low density component, maximizes the use of space and size to convey the UI Design.
   */
  density: PropTypes.oneOf(['touch', 'low', 'medium', 'high']),

  /**
   * The label for the group legend
   */
  legend: PropTypes.node,

  /**
   * The name used to reference the value of the control.
   */
  name: PropTypes.string,

  /**
   * Callback fired when a checkbox is clicked.
   *
   * @param {string} value The `value` of the clicked checkbox
   * @param {bool} checked The new `checked` state of the clicked checkbox
   */
  onChange: PropTypes.func,

  /**
   * @external - material-ui (FormGroup)
   * Display group of elements in a row.
   */
  row: PropTypes.bool
} : void 0; // TODO (BREAKING CHANGE REQUIRED)
// https://issuetracking.jpmchase.net/jira12/browse/JPMUITK-2835
// Add unique JPMUI prefix to name to identify component as a Toolkit component

export default withStyles(CheckboxGroupStyle, {
  name: 'CheckboxGroup'
})(CheckboxGroup);